/** @type {import('types/utils').RetryFnType} */
const retry = ({ retries = 5, interval = 1000 }) => {
    return async (fn) => {
        try {
            return await fn();
        } catch (error) {
            setTimeout(async () => {
                if (retries === 1) {
                    // maximum retries exceeded
                    throw error;
                }

                await retry({ retries: retries - 1, interval })(fn);
            }, interval);

            throw error;
        }
    };
};

export default retry;
